import React from 'react';
import { Container } from './styled';
import { Button } from '../../../../../../../Button/styled';
import { PlayerIcon } from '../../../../../../../Icons';
export const Option = ({ name, isActive, onClick, styles, option, testID, }) => {
    const onClickHandler = () => {
        onClick(option);
    };
    return (React.createElement(Container, { style: styles.container, className: "Option", onClick: onClickHandler },
        React.createElement(Button, { testID: testID, style: styles.optionButton, className: "Option-Button", backgroundColor: "transparent", onClick: onClickHandler },
            React.createElement(PlayerIcon, { style: Object.assign(Object.assign({}, styles.optionCheckMark), { width: 24, height: 24, margin: '0 10px', opacity: isActive ? 1 : 0 }), className: "Option-icon", "data-test": "Option-icon", name: "onPrimary-confirm", isActive })),
        React.createElement("span", { style: styles.optionTitle, "data-test": "Option-Name", className: "Option-Name" }, name)));
};
Option.defaultProps = {
    styles: {
        container: null,
        optionButton: null,
        optionCheckMark: null,
        optionTitle: null,
    },
};
//# sourceMappingURL=index.js.map